<template>
	<div class="expertThinkTank">
		<comHead :tabIndexI="2" :imgSrc="imgSrc" />
		<div class="content-bg">
			<div class="content">
				<el-tabs v-model="selectedType" @tab-click="selectType">
					<el-tab-pane label="全部" name="0"></el-tab-pane>
					<el-tab-pane v-for="(item, index) in types" :key="index" :label="item.FullName" :name="item.Value">
					</el-tab-pane>
					<!-- <el-tab-pane label="国内商标" name="1"></el-tab-pane>
          <el-tab-pane label="国外商标" name="2"></el-tab-pane>
          <el-tab-pane label="版权登记" name="3"></el-tab-pane>
          <el-tab-pane label="法律服务" name="4"></el-tab-pane> -->
				</el-tabs>
				<div class="el_input">
					<el-input v-model.trim="quickQuery" placeholder="请输入专家姓名" />
					<span @click="search">搜索</span>
				</div>
			</div>
		</div>
		<div class="zhaunjiaBg">
			<div class="zhuanjiaCenter">
				<div class="zhuanjiaLeft">
					<div class="tuanduigoucheng">
						<h1>团队构成</h1>
						<p>Talent composition</p>
					</div>
					<div class="zhuanjiaPhoto">
						<img src="../../static/imgs/expertThinkTank/zhuanjiajuzheng.png" alt="" />
					</div>
				</div>
				<div class="zhuanjiaRight">
					<div class="zhuanjiaColumn" v-for="(item, index) in list" :key="index"
						@click="showDetails(item.ExpertId)">
						<div class="zhuanjiaPick">
							<img :src="$urlFile + item.PictureUrl" alt="" />
						</div>
						<div class="zhuanjiaCopy">
							<div class="name">{{ item.ExpertName }}</div>
							<div class="describe">
								<img class="iconPhoto" src="../../static/imgs/expertThinkTank/pick.png" alt="" />
								<div>
									<div class="jieshao" :title="item.ExpertTitle">
										{{ item.ExpertTitle }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- <section class="expertThinkTank_center">
         <div class="expertThinkTank_center_content">
          <div
            class="expertThinkTank_centerItem"
            v-for="(item, index) in list"
            :key="index"
            @click="showDetails(item.ExpertId)"
          >
            <div class="selfPhoto">
              <img :src="$urlFile + item.PictureUrl" alt="" />
            </div>
            <div class="expertThinkTank_centerItemBottom">
              <div class="name">{{ item.ExpertName }}</div>
              <div class="describe">
                <img
                  class="iconPhoto"
                  src="../../static/imgs/expertThinkTank/pick.png"
                  alt=""
                />
                <div>
                  <div class="jieshao" :title="item.ExpertTitle">
                    {{ item.ExpertTitle }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </section>-->
		</div>

		<div class="pagination">
			<el-pagination layout="prev, pager, next" @current-change="pageIndexChange" :current-page.sync="pageIndex"
				:page-size="pageSize" :total="totalCount">
			</el-pagination>
		</div>
		<!-- 蒙版 -->
		<div v-if="isSuperSearchDigShow" class="allMb" @click="isSuperSearchDigShow = false"></div>
		<div class="pop-up" v-if="isSuperSearchDigShow">
			<div class="popup" :style="{ 'max-height': this.timeLineHeight + 'px' }">
				<div class="close" @click="isSuperSearchDigShow = false">
					<img src="../../static/imgs/expertThinkTank/close.png" alt="" />
				</div>
				<div class="PopupWindow">
					<div class="figure">
						<img :src="$urlFile + entity.PictureUrl" alt="" />
					</div>
					<div class="text">
						<h1 class="name">{{ entity.ExpertName }}</h1>
						<div class="post">{{ entity.ExpertTitle }}</div>
						<h2 class="goodAt">擅长领域</h2>
						<p class="goodField">{{ entity.BeExpertIn }}</p>
					</div>
				</div>
				<h2 class="goodAt">专家简介</h2>
				<p class="goodField">{{ entity.Introduction }}</p>
				<h2 class="goodAt" v-if="entity.Masterpiece">代表性论著</h2>
				<p class="goodField" v-if="entity.Masterpiece">
					{{ entity.Masterpiece }}
				</p>
				<h2 class="goodAt" v-if="entity.PolicyAnalyzing">政策解读</h2>
				<p class="goodField" v-if="entity.PolicyAnalyzing">
					{{ entity.PolicyAnalyzing }}
				</p>
			</div>
		</div>

		<comFooter />
	</div>
</template>

<script>
	import {
		getCodeLsit,
		getExpertList,
		getExpert
	} from "../request/api.js";
	export default {
		data() {
			return {
				positionID: this.$route.query.positionID,
				imgSrc: require("../../static/imgs/expertThinkTank/banner.jpg"),
				types: [],
				list: [],
				pageIndex: 1,
				pageSize: 6,
				totalCount: 0,
				quickQuery: "",
				selectedType: 0,
				expertName: "",
				timeLineHeight: "",
				isSuperSearchDigShow: false,
				entity: {
					ExpertId: 0,
					ExpertName: "", // 姓名
					TypeText: "", //专家分类
					ExpertTitle: "", // 职位
					PictureUrl: "", // 照片
					Introduction: "", // 简介
					BeExpertIn: "", // 擅长领域
					TrainDirection: "", // 培训方向
					Masterpiece: "", // 代表性论著
					PolicyAnalyzing: "", // 政策解读
				},
			};
		},
		created() {
			getCodeLsit({
				code: "ExpertType"
			}).then((data) => {
				if (data.StatusCode == 200) {
					this.types = data.Result || [];
					if (this.positionID) {
						this.afterLoad();
					} else this.loadList();
				} else console.log(data.Msg);
			});
		},
		methods: {
			btnClick() {
				this.click();
				this.show = false;
			},
			mounted() {
				this.timeLineHeight = document.documentElement.clientHeight - 20;
				window.orient = () => {
					this.timeLineHeight = document.documentElement.clientHeight - 20;
				};
			},
			selectType(tab, event) {
				this.selectedType = tab.name;
				this.resetSearch();
			},
			pageIndexChange(val) {
				this.pageIndex = val;
				this.loadList();
				this.toTop();
			},
			search() {
				this.pageIndex = 1;
				this.expertName = this.quickQuery;
				this.loadList();
			},
			resetSearch() {
				this.quickQuery = "";
				this.expertName = "";
				this.pageIndex = 1;
				this.pageSize = 6;
				this.loadList();
			},
			loadList() {
				getExpertList({
					PageInfo: {
						PageIndex: this.pageIndex - 1,
						PageSize: this.pageSize,
					},
					ExpertName: this.expertName,
					ExpertType: this.selectedType,
				}).then((data) => {
					// console.log(data.Result);
					this.list = data.Result;
					this.totalCount = data.TotalCount;
				});
			},
			showDetails(id) {
				getExpert({
					expertId: id
				}).then((data) => {
					// console.log(data.Result);
					this.entity = data.Result;
					this.isSuperSearchDigShow = true;
				});
			},
			toTop() {
				const that = this;
				let timer = setTimeout(() => {
					let ispeed = Math.floor(-that.scrollTop / 5);
					document.documentElement.scrollTop = document.body.scrollTop =
						that.scrollTop + ispeed;
					if (that.scrollTop === 0) {
						clearTimeout(timer);
					}
				}, 30);
			},
			afterLoad() {
				let num = Number(this.positionID.substr(-1));
				switch (num) {
					case 1:
						this.selectedType = "1";
						break;
					case 2:
						this.selectedType = "5";
						break;
					case 3:
						this.selectedType = "2";
						break;
					case 4:
						this.selectedType = "3";
						break;
					case 5:
						this.selectedType = "6";
						break;
					case 6:
						this.selectedType = "4";
						break;
				}
				this.loadList();
			},
		},
	};
</script>
<style lang="scss" scoped>
	@import "../assets/style/index.scss";

	/deep/ .el-tabs__item.is-active {
		font-size: 1.25rem !important;
		line-height: 1rem !important;
		color: #0055a2 !important;
	}

	/deep/ .el-tabs__item {
		color: #333 !important;
		font-size: 1rem;
		height: auto;
	}

	/deep/ .el-tabs__active-bar {
		background: #0c56b0 !important;
	}

	/deep/ .el-tabs__nav-wrap::after {
		background: none !important;
	}

	.expertThinkTank {
		background: #fff !important;

		.content-bg {
			background: #f7f7f7 !important;
			padding: 2rem;
		}

		.content {
			min-width: 1200px;
			width: 62.5vw;
			height: auto;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;

			.el_input {
				width: 11rem;
				display: flex;
				flex-wrap: nowrap;
				border: 1px solid #0055a2;

				.el-input {
					width: 14.375rem;

					/deep/ .el-input__inner {
						border: none !important;
						padding: 0 8px;
					}
				}

				span {
					width: 6.25rem;
					height: 2.5rem;
					color: #fff;
					background: #0055a2;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;
				}
			}
		}

		@media screen and (max-width: 750px) {
			/deep/ .el-tabs__item.is-active {
				font-size: 1.2rem !important;
				line-height: 2rem !important;
				color: #0055a2 !important;
			}

			/deep/ .el-tabs__item {
				color: #333 !important;
				font-size: 1rem;
				height: auto;
				padding: 0 10px;
			}

			.content-bg {
				background: #f7f7f7 !important;
				padding: 1rem 0 1.4rem 0;
			}

			.content {
				height: auto;
				margin: 0 auto;
				display: block;
				min-width: 20rem;

				.el_input {
					width: 19.625rem;
					display: flex;
					flex-wrap: nowrap;
					border: 1px solid #0055a2;
					margin-top: 1.4rem;
					font-size: 0.8rem;
					text-align: center;

					.el-input {
						width: 14.375rem;

						/deep/ .el-input__inner {
							border: none !important;
							padding: 1rem 0 1rem 1rem;
							font-size: 0.8rem;
						}
					}

					span {
						width: 5.25rem;
						height: 2.5rem;
						color: #fff;
						background: #0055a2;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						padding: 1rem 0;
					}
				}
			}
		}

		@media screen and (max-width: 420px) {
			/deep/ .el-tabs__item.is-active {
				font-size: 1.2rem !important;
				line-height: 2rem !important;
				color: #0055a2 !important;
			}

			/deep/ .el-tabs__active-bar {
				display: none;
			}

			/deep/ .el-tabs__nav {
				width: 90vw;
				white-space: initial;
			}

			/deep/ .el-tabs__item {
				color: #333 !important;
				font-size: 1rem;
				height: auto;
				padding: 0 10px;
			}

			.content {
				height: auto;
				margin: 0 auto;
				display: block;
				width: 44rem;

				.el_input {
					width: 17rem;
					display: flex;
					flex-wrap: nowrap;
					border: 1px solid #0055a2;
					// margin-top: 2rem;

					// font-size: 1.5rem;
					text-align: center;

					.el-input {
						width: 14.375rem;

						/deep/ .el-input__inner {
							border: none !important;
							padding: 1.6rem 0 1.6rem 1rem;
							// font-size: 1.5rem;
						}
					}

					span {
						width: 5.25rem;
						height: 2.5rem;
						color: #fff;
						background: #0055a2;
						display: flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;
						padding: 1.6rem 0;
					}
				}
			}
		}


		.expertThinkTank_centerTitle {
			color: #333;
			font-size: 1rem;
			margin-bottom: 1.25rem;
		}

		.pagination {
			margin: 2rem 0 3.5rem;
			text-align: center;
		}

		.checked {
			color: rgb(181, 54, 81) !important;
			border-bottom: 2px solid rgb(181, 54, 81) !important;
		}

		.expertThinkTank_center_content {
			display: flex;
			flex-wrap: wrap;
		}

		.expertThinkTank_center_head {
			display: flex;
			justify-content: space-between;
			align-items: center;

			div:first-child {
				display: flex;

				div {
					cursor: pointer;
					margin-right: 1.25rem;
					font-size: 0.875rem;
					color: #333;
					padding-bottom: 0.25rem;
					border-bottom: 0.125rem solid transparent;
				}
			}
		}

		.fengeImg {
			margin: auto;
			width: $contentWidth;
		}

		.el-input__icon {
			cursor: pointer;
			font-size: 1.5rem;
		}

		.Headcontent {
			display: flex;
			justify-content: space-around;
		}

		.HeadcontentItem {
			.count {
				color: rgb(202, 0, 11);
				position: absolute;
				right: 1.25rem;
				top: 0.625rem;
			}

			height: 10.625rem;
			width: 18.125rem;
			border: 0.0625rem solid #dedede;
			position: relative;
			background: white;
			padding: 2.5rem;

			img {
				position: absolute;
				top: -1.25rem;
				left: 1.25rem;
			}

			.HeadcontentItem_title {
				margin-bottom: 0.625rem;
			}

			.HeadcontentItem_dis {
				font-size: 0.875rem;
				color: #999;
			}
		}

		@media screen and (max-width: 750px) {
			.expertThinkTank_center_content {
				width: 100%;
				padding-top: 1rem;

				.expertThinkTank_centerItem {
					cursor: pointer;
					flex: 0 0 16.25rem;
					// height: 330px;
					// background: crimson;
					margin: 0 auto;
					padding-bottom: 4rem;
					width: 50%;

					.expertThinkTank_centerItemBottom {
						background: #f7f7f7;
						padding: 1.25rem;
						border: 0.0625rem solid #dedede;
						border-top: none;
						width: 16.25rem;

						.name {
							font-size: 1.25rem;
							font-weight: 600;
							color: #333;
						}

						.describe {
							display: flex;
							align-items: center;
							margin-top: 1rem;

							.iconPhoto {
								margin-right: 0.5rem;
							}
						}

						div {
							font-size: 1.8rem;
						}

						.jieshao {
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 1;
							overflow: hidden;
							font-size: 1rem;
						}
					}

					.selfPhoto {
						width: 16.25rem;
						height: 18.75rem;
						overflow: hidden;

						img {
							width: 16.25rem;
							height: 21.75rem;
						}
					}
				}
			}
		}

		.allMb {
			position: fixed;
			height: 100%;
			width: 100%;
			background: rgba(0, 0, 0, 0.6);
			z-index: 20;
			bottom: 0;
			right: 0;
		}

		.popup {
			border-radius: 2px;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
			box-sizing: border-box;
			margin-bottom: 50px;
			position: fixed;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			width: 50rem;
			height: 37.5rem;
			background: #f0f0f0;
			overflow-y: scroll;
			z-index: 21;
			padding: 1.875rem 1.875rem 3rem 1.875rem;

			.close {
				position: absolute;
				right: 1.875rem;
				top: 1.875rem;
				cursor: pointer;
			}

			.PopupWindow {
				display: flex;
				align-items: center;
				justify-content: flex-start;

				.figure {
					margin-right: 2.5rem;

					img {
						width: 16.25rem;
						height: 21.75rem;
					}
				}

				.text {
					.name {
						font-size: 1.5rem;
						color: #333;
						font-weight: bold;
						margin-bottom: 1.5rem;
					}

					.post {
						font-size: 0.875rem;
						color: #333;
						line-height: 1.4rem;
						width: 88%;
					}
				}
			}
		}

		.goodAt {
			font-size: 1rem;
			color: #333;
			margin-bottom: 1.6rem;
			font-weight: bold;
			padding-top: 2.5rem;
		}

		.goodField {
			font-size: 0.875rem;
			color: #333;
			line-height: 1.4rem;
		}

		@media screen and (max-width: 750px) {
			.popup {
				width: 90%;

				.close {
					position: absolute;
					right: 0.5rem;
					top: 0.6rem;
					cursor: pointer;
				}

				.PopupWindow {
					display: block;

					.figure {
						margin-right: 0;
						display: block;
						text-align: center;

						img {
							width: 100%;
						}
					}

					.text {
						.name {
							margin-top: 2rem;
						}
					}
				}
			}
		}

		.zhaunjiaBg {
			background: url(../../static/imgs/expertThinkTank/juzhenbg.png) no-repeat top;
			width: 100%;

			.zhuanjiaCenter {
				max-width: 1200px;
				margin: 0 auto;
				display: flex;
				justify-content: space-between;

				.zhuanjiaLeft {
					width: 30%;

					.tuanduigoucheng {
						color: #fff;
						display: flex;
						align-items: center;
						padding: 50px 0 60px 0;

						h1 {
							font-size: 36px;
							margin-right: 20px;
						}

						p {
							font-size: 16px;
						}
					}

					.zhuanjiaPhoto {
						width: 100%;
						position: relative;

						img {
							position: absolute;
							left: -180px;
							top: 10px;
						}
					}
				}

				.zhuanjiaRight {
					width: 62%;
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
					padding: 40px 10px 0;
					height: 716px;

					.zhuanjiaColumn {
						width: 27.68%;
						margin: 20px 20px;

						.zhuanjiaPick {
							width: 200px;
							height: 200px;
							overflow: hidden;

							img {
								width: 200px;
								height: 267px;
							}
						}

						.zhuanjiaCopy {
							background: #f7f7f7;
							padding: 1rem;
							border: 0.0625rem solid #dedede;
							border-top: none;

							.name {
								font-size: 1.25rem;
								font-weight: 600;
								color: #333;
							}

							.describe {
								display: flex;
								align-items: center;
								margin-top: 0.8rem;

								.iconPhoto {
									margin-right: 0.5rem;
								}
							}

							.jieshao {
								display: -webkit-box;
								-webkit-box-orient: vertical;
								-webkit-line-clamp: 1;
								overflow: hidden;
								font-size: 1rem;
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 500px) {
		.expertThinkTank {
			width: 100vw;
			.content-bg{
				padding: 0 5px
			}
			.content{
				width: 98vw;
				.el_input{
					margin: 10px 0;
				}
			}
			.zhaunjiaBg{
				width: 100vw;
				padding: 0 5px;
				background: url(../../static/imgs/expertThinkTank/juzhenbg.png) no-repeat -200px top;
				.zhuanjiaCenter{
					max-width: 100vw;
					display: initial;
					.zhuanjiaLeft{
						width: 98vw;
						.zhuanjiaPhoto{
							img{
								position: relative;
								width: 98vw;
								left: 0px;
								top: 0px;
							}
						}
					}
					.zhuanjiaRight{
						width: 98vw;
						padding: 0;
						height: auto;
						.zhuanjiaColumn{
							width: 45vw;
							margin: 5px;
							.zhuanjiaPick{
								width: 100%;
							}
						}
					}
					
				}
			}
		.pagination{
			width: 80vw;
			margin: 0 auto;
		}
		.popup{
			width: 100vw;
			left: 0;
			transform:inherit;
			top:0;
		}
		}
	}
</style>
